import styled from 'styled-components';

export const Wrapper = styled.div<{ $hasValue: boolean }>`
  .ant-select-selector {
    border: 1px solid
      ${({ theme, $hasValue }) => ($hasValue ? theme.colors.green7 : theme.colors.black4)} !important;
    background-color: ${({ theme, $hasValue }) =>
      $hasValue ? theme.colors.green2 : 'transparent'} !important;

    &:hover {
      border-color: ${({ theme }) => theme.colors.black4} !important;
      background-color: ${({ theme }) => theme.colors.green1} !important;
    }

    &:focus {
      border-color: ${({ theme }) => theme.colors.green7} !important;
      background-color: ${({ theme }) => theme.colors.green2} !important;
    }

    &:active {
      border-color: ${({ theme }) => theme.colors.green7} !important;
      background-color: ${({ theme }) => theme.colors.green2} !important;
    }
  }

  .ant-select-selection-placeholder {
    color: ${({ theme }) => theme.colors.black9} !important;
  }
`;

export const DropdownWrapper = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 300px;
`;

export const ItemWrapper = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 4px;
  padding: 4px;
  border-radius: 4px;
  background-color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.colors.green2 : 'transparent'};
  cursor: pointer;
  color: ${({ $isSelected, theme }) => ($isSelected ? theme.colors.green7 : theme.colors.black9)};
  border: ${({ $isSelected, theme }) =>
    $isSelected ? `1px solid ${theme.colors.green7}` : 'none'};

  &:hover {
    background-color: ${({ theme }) => theme.colors.green1};
  }
`;

export const ItemTextWrapper = styled.div`
  width: 100%;
  min-width: 80px;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  overflow-y: auto;
  padding: 8px 0;
`;
export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
`;

export const CounterWrapper = styled.div<{ $isDisabled: boolean }>`
  display: flex;
  height: 16px;
  padding: 0px 6px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: ${({ theme, $isDisabled }) =>
    $isDisabled ? theme.colors.black5 : theme.colors.green7};
  color: ${({ theme }) => theme.colors.white};
`;
